import React, { useState } from "react";
import { BsFillCloudUploadFill } from "react-icons/bs";
import UserImage from "../../assets/userImage.png";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import { useAuth } from "../../context/Auth";
import { useNavigate } from "react-router-dom";
import InputField from "../../components/FormFields/InputField";
import RadioGroup from "../../components/FormFields/RadioGroup";

const AddVisitor = () => {
    const { requestWithAuth } = useAuth();
    const navigate = useNavigate();

    const [data, setData] = useState({});
    const [file, setFile] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        if (type === "file") {
            setFile(files[0]);
            setData((prevData) => ({
                ...prevData,
                [name]: files[0],
            }));
        } else {
            setData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
        // Clear error for the specific field when it's changed
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: undefined,
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!data.first_name) newErrors.first_name = "First Name is required.";
        if (!data.last_name) newErrors.last_name = "Last Name is required.";
        if (!data.gender) newErrors.gender = "Gender is required.";
        if (!data.address) newErrors.address = "Address is required.";
        if (!data.phone_number) newErrors.phone_number = "Phone Number is required.";
        if (!data.date_of_birth) newErrors.date_of_birth = "Date of Birth is required.";
        if (!data.hometown) newErrors.hometown = "Hometown is required.";
        if (!data.nationality) newErrors.nationality = "Nationality is required.";
        if (!data.residence) newErrors.residence = "Residence is required.";
        if (!data.language_spoken) newErrors.language_spoken = "Language Spoken is required.";
        if (!data.marital_status) newErrors.marital_status = "Marital Status is required.";
        if (!data.born_again) newErrors.born_again = "Please specify if born again.";
        if (!data.holy_spirit_baptized) newErrors.holy_spirit_baptized = "Please specify if Holy Spirit baptized.";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const submitForm = async () => {
        if (!validateForm()) {
            toast.error("Please fill in all required fields.");
            return;
        }

        setSubmitting(true);
        const formData = new FormData();
        Object.keys(data).forEach((key) => {
            formData.append(key, data[key]);
        });

        try {

            await requestWithAuth("/members/visitors/list/", "POST", formData, {
                'Content-Type': 'multipart/form-data',
            });

            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Visitor has been created successfully",
                confirmButtonColor: '#3085d6',
            }).then(() => {
                navigate("/visitors");
            });
        } catch (error) {
            console.error("Submission error:", error);
            const errorMessage = error.response?.data?.detail || "An error occurred during submission. Please try again.";
            toast.error(errorMessage);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen p-6">
            <div className=" mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
                {/* Header */}
                <div className="px-6 py-5 bg-blue-600 text-white">
                    <h1 className="text-2xl font-bold">ADD NEW VISITOR</h1>
                </div>

                <div className="p-6">
                    {/* PERSONAL INFORMATION */}
                    <div className="mb-8">
                        <h2 className="text-xl font-semibold text-gray-800 border-b pb-3 mb-5">
                            PERSONAL INFORMATION
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            {/* Personal Info Details */}
                            <div className="md:col-span-2 space-y-5">
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                                    <InputField
                                        label="First Name"
                                        name="first_name"
                                        value={data.first_name}
                                        onChange={handleChange}
                                        required
                                        error={errors.first_name}
                                    />
                                    <InputField
                                        label="Last Name"
                                        name="last_name"
                                        value={data.last_name}
                                        onChange={handleChange}
                                        required
                                        error={errors.last_name}
                                    />
                                    <RadioGroup
                                        label="Gender"
                                        name="gender"
                                        options={[{ label: 'Male', value: 'Male' }, { label: 'Female', value: 'Female' }]}
                                        value={data.gender}
                                        onChange={handleChange}
                                        required
                                        error={errors.gender}
                                    />
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                                    <InputField
                                        label="Address"
                                        name="address"
                                        value={data.address}
                                        onChange={handleChange}
                                        required
                                        error={errors.address}
                                    />
                                    <InputField
                                        label="Phone Number"
                                        name="phone_number"
                                        value={data.phone_number}
                                        onChange={handleChange}
                                        required
                                        error={errors.phone_number}
                                    />
                                    <InputField
                                        label="Email"
                                        name="email"
                                        type="email"
                                        value={data.email}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                                    <InputField
                                        label="Date of Birth"
                                        name="date_of_birth"
                                        type="date"
                                        value={data.date_of_birth}
                                        onChange={handleChange}
                                        required
                                        error={errors.date_of_birth}
                                    />
                                    <InputField
                                        label="Hometown"
                                        name="hometown"
                                        value={data.hometown}
                                        onChange={handleChange}
                                        required
                                        error={errors.hometown}
                                    />
                                    <InputField
                                        label="Nationality"
                                        name="nationality"
                                        value={data.nationality}
                                        onChange={handleChange}
                                        required
                                        error={errors.nationality}
                                    />
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                                    <InputField
                                        label="Residence"
                                        name="residence"
                                        value={data.residence}
                                        onChange={handleChange}
                                        required
                                        error={errors.residence}
                                    />
                                    <InputField
                                        label="Language Spoken"
                                        name="language_spoken"
                                        value={data.language_spoken}
                                        onChange={handleChange}
                                        required
                                        error={errors.language_spoken}
                                    />
                                    <div className="invisible"></div> {/* Empty space for layout */}
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                                    <RadioGroup
                                        label="Marital Status"
                                        name="marital_status"
                                        options={[
                                            { label: 'Single', value: 'Single' },
                                            { label: 'Married', value: 'Married' },
                                            { label: 'Divorced', value: 'Divorced' },
                                            { label: 'Remarried', value: 'Remarried' },
                                            { label: 'Co-Habitation', value: 'Co-Habitation' },
                                        ]}
                                        value={data.marital_status}
                                        onChange={handleChange}
                                        required
                                        error={errors.marital_status}
                                    />
                                </div>
                            </div>

                            {/* Image Upload */}
                            <div className="md:col-span-1 flex flex-col items-center justify-start py-5">
                                <div className="w-40 h-40 rounded-full overflow-hidden border-4 border-blue-200 shadow-md mb-4">
                                    <img
                                        src={file ? URL.createObjectURL(file) : UserImage}
                                        alt="Visitor"
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    name="profile_picture"
                                    id="profile_picture"
                                    onChange={handleChange}
                                    className="hidden"
                                />
                                <label
                                    htmlFor="profile_picture"
                                    className="flex items-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md cursor-pointer transition-colors shadow-sm text-sm font-medium"
                                >
                                    <BsFillCloudUploadFill className="text-lg" />
                                    Upload File
                                </label>
                                <p className="mt-2 text-xs text-gray-500">
                                    {file ? file.name : "No file selected"}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* SPIRITUAL LIFE INFORMATION */}
                    <div className="mb-8">
                        <h2 className="text-xl font-semibold text-gray-800 border-b pb-3 mb-5">
                            SPIRITUAL LIFE INFORMATION
                        </h2>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                            <InputField
                                label="Area of Ministry/Gifting"
                                name="ministry"
                                value={data.ministry}
                                onChange={handleChange}
                            />
                            <RadioGroup
                                label="Are You Born Again?"
                                name="born_again"
                                options={[{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }]}
                                value={data.born_again}
                                onChange={handleChange}
                                required
                                error={errors.born_again}
                            />
                            <RadioGroup
                                label="Holy Spirit Baptized?"
                                name="holy_spirit_baptized"
                                options={[{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }]}
                                value={data.holy_spirit_baptized}
                                onChange={handleChange}
                                required
                                error={errors.holy_spirit_baptized}
                            />
                        </div>
                    </div>

                    {/* Submit Button / Loader */}
                    <div className="flex justify-end pt-6 border-t border-gray-200">
                        {submitting ? (
                            <div className="flex items-center justify-center">
                                <ThreeDots
                                    height="40"
                                    width="40"
                                    radius="9"
                                    color="#2563EB"
                                    ariaLabel="three-dots-loading"
                                    visible={true}
                                />
                            </div>
                        ) : (
                            <button
                                onClick={submitForm}
                                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                            >
                                Submit
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddVisitor;